import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../../service/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class UserInterceptor implements HttpInterceptor {
  constructor(private userService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.userService.getToken();
    const authRequest = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + (authToken || ''))
    });

    const skipLogout = req.url.indexOf('userLogin') !== -1;

    return next.handle(authRequest).pipe(
      map((event: HttpEvent<any>) => {
        if (!skipLogout && event instanceof HttpResponse) {
          const bodyStatus = event.body && event.body.status;
          if (bodyStatus === 401 || bodyStatus === '401') {
            this.forceLogout();
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (!skipLogout && error.status === 401) {
          this.forceLogout();
        }
        return throwError(error);
      })
    );
  }

  private forceLogout() {
    if (this.userService.getIsAuth() || this.userService.getToken()) {
      this.userService.dlogout();
    }
  }
}
